
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Category, CategoryType } from "@/viewmodels/Category";

@Component({})
export default class extends Vue {
  public collection = app.categoryCollection;
  public search: string = "";
  public model: Category = new Category({}, this.collection);
  public selectedModel: Category | null = null;

  public dialog = false;
  public formTitle: string = "Food Category";

  public headers = [
    { text: "Name", value: "name" },
    { text: "Type", value: "type" },
    { text: "Keywords", value: "keywords" },
    { text: "Actions", value: "" }
  ];

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Category({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Category) {
    this.model = item;
    this.dialog = true;
  }
}
